export const uploadModal = {
  dropzone: 'Drag and drop your CSV file here',
  chooseFile: 'Choose File',
  download: 'or download',
  template: 'template'
};

export default uploadModal;
